document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const root=document.documentElement;
  const savedTheme=localStorage.getItem('virelto-theme');
  if(savedTheme==='dark'||savedTheme==='light')root.dataset.theme=savedTheme;

  document.querySelectorAll('[data-theme-toggle]').forEach(button=>{
    button.addEventListener('click',()=>{
      const next=root.dataset.theme==='dark'?'light':'dark';
      root.dataset.theme=next;
      localStorage.setItem('virelto-theme',next);
      const label=next==='dark'?button.dataset.labelLight:button.dataset.labelDark;
      if(label)button.setAttribute('aria-label',label);
    });
  });

  document.querySelectorAll('[data-language-switcher]').forEach(switcher=>{
    const toggle=switcher.querySelector('[data-language-toggle]');
    const menu=switcher.querySelector('[data-language-menu]');
    if(!toggle||!menu)return;
    const closeMenu=()=>{menu.setAttribute('hidden','');toggle.setAttribute('aria-expanded','false');};
    toggle.addEventListener('click',event=>{
      event.stopPropagation();
      const isOpen=!menu.hasAttribute('hidden');
      if(isOpen){closeMenu();}else{menu.removeAttribute('hidden');toggle.setAttribute('aria-expanded','true');}
    });
    document.addEventListener('click',event=>{if(!switcher.contains(event.target))closeMenu();});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu();});
  });

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(button=>{
    button.addEventListener('click',()=>{
      document.body.classList.toggle('menu-open');
      button.setAttribute('aria-expanded',document.body.classList.contains('menu-open')?'true':'false');
    });
  });

  document.querySelectorAll('.quick-add-form').forEach(form=>{form.dataset.quickAddBound='true';
    form.addEventListener('submit',async event=>{
      if(!window.fetch)return;
      event.preventDefault();
      const button=form.querySelector('button');
      const original=button.innerHTML;
      const addingLabel=form.dataset.addingLabel||'Adding…';
      const addedLabel=form.dataset.addedLabel||'Added ✓';
      button.disabled=true;
      button.textContent=addingLabel;
      try{
        const rootPath=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
        const response=await fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(form.querySelector('[name="id"]').value),quantity:1})});
        if(!response.ok)throw new Error('Unable to add item');
        const cart=await fetch(rootPath+'cart.js').then(r=>r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
        button.textContent=addedLabel;
        setTimeout(()=>{button.innerHTML=original;button.disabled=false;},1100);
      }catch(error){
        const isSpanish=(document.documentElement.lang||'').toLowerCase().startsWith('es');
        button.textContent=isSpanish?'No se pudo agregar':'Could not add';
        window.setTimeout(()=>{button.innerHTML=original;button.disabled=false;},1300);
      }
    });
  });


  // ZHOPU INFINITE PRODUCT LISTS
  const getFreshProductSeed=()=>{
    let seed=(Date.now()^Math.floor(Math.random()*0xffffffff))>>>0;
    try{
      if(window.crypto?.getRandomValues){
        const values=new Uint32Array(1);
        window.crypto.getRandomValues(values);
        seed=values[0]>>>0;
      }
    }catch(error){}
    return seed;
  };

  const seededRandom=seed=>{
    let value=seed>>>0;
    return ()=>{
      value+=0x6D2B79F5;
      let t=value;
      t=Math.imul(t^t>>>15,t|1);
      t^=t+Math.imul(t^t>>>7,t|61);
      return ((t^t>>>14)>>>0)/4294967296;
    };
  };

  const hashString=value=>{
    let hash=2166136261;
    for(let i=0;i<value.length;i++){
      hash^=value.charCodeAt(i);
      hash=Math.imul(hash,16777619);
    }
    return hash>>>0;
  };

  const seededShuffle=(items,seed)=>{
    const list=[...items];
    const random=seededRandom(seed);
    for(let i=list.length-1;i>0;i--){
      const j=Math.floor(random()*(i+1));
      [list[i],list[j]]=[list[j],list[i]];
    }
    return list;
  };

  const bindDynamicQuickAdd=()=>{
    if(document.documentElement.dataset.dynamicQuickAdd==='true')return;
    document.documentElement.dataset.dynamicQuickAdd='true';

    document.addEventListener('submit',async event=>{
      const form=event.target.closest?.('.quick-add-form');
      if(!form||form.dataset.quickAddBound==='true'||!window.fetch)return;

      event.preventDefault();
      const button=form.querySelector('button');
      if(!button||button.disabled)return;

      const original=button.innerHTML;
      const addingLabel=form.dataset.addingLabel||'Adding…';
      const addedLabel=form.dataset.addedLabel||'Added ✓';
      button.disabled=true;
      button.textContent=addingLabel;

      try{
        const rootPath=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
        const response=await fetch(rootPath+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:Number(form.querySelector('[name="id"]').value),quantity:1})
        });
        if(!response.ok)throw new Error('Unable to add item');

        const cart=await fetch(rootPath+'cart.js',{cache:'no-store'}).then(r=>r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el=>{
          el.textContent=String(cart.item_count);
          el.hidden=false;
        });

        button.textContent=addedLabel;
        window.setTimeout(()=>{button.innerHTML=original;button.disabled=false;},1100);
      }catch(error){
        const isSpanish=(document.documentElement.lang||'').toLowerCase().startsWith('es');
        button.textContent=isSpanish?'No se pudo agregar':'Could not add';
        window.setTimeout(()=>{button.innerHTML=original;button.disabled=false;},1300);
      }
    });
  };

  bindDynamicQuickAdd();

  document.querySelectorAll('[data-infinite-products]').forEach(section=>{
    const grid=section.querySelector('[data-infinite-grid]');
    const sentinel=section.querySelector('[data-infinite-sentinel]');
    const status=section.querySelector('[data-infinite-status]');
    const loadingText=status?.querySelector('[data-infinite-loading]');
    const completeText=status?.querySelector('[data-infinite-complete]');
    if(!grid||!sentinel)return;

    const totalPages=Math.max(1,parseInt(grid.dataset.totalPages||'1',10)||1);
    const currentPage=Math.max(1,parseInt(grid.dataset.currentPage||'1',10)||1);
    const initialCards=[...grid.children].filter(el=>el.classList.contains('product-card'));
    const batchSize=Math.max(1,initialCards.length||16);

    // Generate a new order on every category/search page load.
    // The order stays fixed while this page is open, so infinite scrolling
    // never jumps or repeats products, but revisiting/refreshing gives variety.
    const pageSeed=getFreshProductSeed();

    const setLoading=value=>{
      if(loadingText)loadingText.hidden=!value;
      if(value&&completeText)completeText.hidden=true;
    };

    const cardKey=card=>{
      if(card.dataset.productId)return card.dataset.productId;
      const link=card.querySelector('a[href*="/products/"]');
      return link?.getAttribute('href')||card.outerHTML;
    };

    const buildVariedOrder=cards=>{
      const groups=new Map();

      cards.forEach(card=>{
        const key=(card.dataset.productType||'').trim().toLowerCase()||'__other__';
        if(!groups.has(key))groups.set(key,[]);
        groups.get(key).push(card);
      });

      let active=[...groups.entries()].map(([key,items])=>({
        key,
        items:seededShuffle(items,(pageSeed^hashString('type:'+key))>>>0),
        index:0
      }));

      const ordered=[];
      let cycle=0;

      while(active.length){
        const cycleGroups=seededShuffle(active,(pageSeed^hashString('cycle:'+cycle))>>>0);
        cycleGroups.forEach(group=>{
          if(group.index<group.items.length){
            ordered.push(group.items[group.index]);
            group.index+=1;
          }
        });
        active=active.filter(group=>group.index<group.items.length);
        cycle+=1;
      }

      return ordered;
    };

    const fetchPage=async(page,attempt=0)=>{
      const url=new URL(window.location.href);
      url.searchParams.set('page',String(page));

      try{
        const response=await fetch(url.toString(),{
          headers:{'X-Requested-With':'XMLHttpRequest'},
          cache:'no-store'
        });
        if(!response.ok)throw new Error('Unable to load products');

        const html=await response.text();
        const doc=new DOMParser().parseFromString(html,'text/html');
        const selector=section.dataset.gridSelector||'.collection-products';
        const nextGrid=doc.querySelector(selector);
        if(!nextGrid)return [];

        return [...nextGrid.children].filter(el=>el.classList.contains('product-card'));
      }catch(error){
        if(attempt<1)return fetchPage(page,attempt+1);
        throw error;
      }
    };

    const initialize=async()=>{
      setLoading(true);
      grid.style.visibility='hidden';

      const pool=new Map();
      initialCards.forEach(card=>pool.set(cardKey(card),card));

      const pages=[];
      for(let page=1;page<=totalPages;page++){
        if(page!==currentPage)pages.push(page);
      }

      const results=await Promise.allSettled(pages.map(page=>fetchPage(page)));
      let failedPages=0;

      results.forEach(result=>{
        if(result.status!=='fulfilled'){
          failedPages+=1;
          return;
        }
        result.value.forEach(card=>{
          const key=cardKey(card);
          if(!pool.has(key))pool.set(key,card);
        });
      });

      const ordered=buildVariedOrder([...pool.values()]);
      let cursor=0;
      let finished=false;
      let observer=null;

      grid.replaceChildren();

      const finish=()=>{
        if(finished)return;
        finished=true;
        setLoading(false);
        if(completeText){
          completeText.hidden=false;
          if(failedPages>0){
            completeText.textContent=(document.documentElement.lang||'').toLowerCase().startsWith('es')
              ?'Se mostraron los productos disponibles. Actualiza para reintentar cualquier carga pendiente.'
              :'Available products are shown. Refresh to retry any pending load.';
          }
        }
        sentinel.hidden=true;
        observer?.disconnect();
      };

      const appendNextBatch=()=>{
        if(finished)return;

        const next=ordered.slice(cursor,cursor+batchSize);
        if(!next.length){
          finish();
          return;
        }

        const fragment=document.createDocumentFragment();
        next.forEach(card=>fragment.appendChild(card));
        grid.appendChild(fragment);
        cursor+=next.length;

        if(cursor>=ordered.length)finish();
      };

      appendNextBatch();
      grid.style.visibility='';
      section.classList.add('is-infinite-ready');
      setLoading(false);

      if(finished)return;

      if('IntersectionObserver'in window){
        observer=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            if(entry.isIntersecting)appendNextBatch();
          });
        },{rootMargin:'700px 0px 700px 0px'});
        observer.observe(sentinel);
      }else{
        const onScroll=()=>{
          if(finished){
            window.removeEventListener('scroll',onScroll);
            return;
          }
          const rect=sentinel.getBoundingClientRect();
          if(rect.top<window.innerHeight+700)appendNextBatch();
        };
        window.addEventListener('scroll',onScroll,{passive:true});
        onScroll();
      }
    };

    initialize().catch(()=>{
      grid.replaceChildren(...initialCards);
      grid.style.visibility='';
      section.classList.add('is-infinite-ready');
      setLoading(false);
      if(completeText)completeText.hidden=true;
      sentinel.hidden=true;
    });
  });

  document.querySelectorAll('[data-virelto-product]').forEach(section=>{
    const main=section.querySelector('[data-gallery-main]');
    const stage=section.querySelector('[data-gallery-stage]');
    const thumbs=[...section.querySelectorAll('[data-gallery-thumb]')];
    const count=section.querySelector('[data-gallery-count]');
    const prevButton=section.querySelector('[data-gallery-prev]');
    const nextButton=section.querySelector('[data-gallery-next]');
    let activeIndex=Math.max(0,thumbs.findIndex(item=>item.classList.contains('is-active')));

    const getVisibleThumbs=()=>thumbs.filter(item=>!item.hidden);

    const updateGalleryControls=()=>{
      const visible=getVisibleThumbs();
      const activeThumb=thumbs[activeIndex];
      const visibleIndex=Math.max(0,visible.indexOf(activeThumb));
      if(count)count.textContent=`${visibleIndex+1} / ${Math.max(visible.length,1)}`;
      if(prevButton)prevButton.hidden=visible.length<=1;
      if(nextButton)nextButton.hidden=visible.length<=1;
    };

    const showImage=index=>{
      if(!main||!thumbs.length)return;
      const button=thumbs[index];
      if(!button||button.hidden)return;
      activeIndex=index;
      main.classList.add('is-changing');
      window.setTimeout(()=>{
        main.src=button.dataset.imageSrc||main.src;
        if(button.dataset.imageSrcset)main.srcset=button.dataset.imageSrcset;
        main.alt=button.dataset.imageAlt||'';
        thumbs.forEach(item=>{
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-current','true');
        updateGalleryControls();
        button.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
        main.classList.remove('is-changing');
      },90);
    };

    const moveGallery=direction=>{
      const visible=getVisibleThumbs();
      if(visible.length<=1)return;
      const activeThumb=thumbs[activeIndex];
      let position=visible.indexOf(activeThumb);
      if(position<0)position=0;
      const target=visible[(position+direction+visible.length)%visible.length];
      showImage(thumbs.indexOf(target));
    };

    thumbs.forEach((button,index)=>button.addEventListener('click',()=>showImage(index)));
    prevButton?.addEventListener('click',()=>moveGallery(-1));
    nextButton?.addEventListener('click',()=>moveGallery(1));
    stage?.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();moveGallery(-1);}
      if(event.key==='ArrowRight'){event.preventDefault();moveGallery(1);}
    });

    const form=section.querySelector('form.virelto-product-form');
    const variantSelect=section.querySelector('[data-product-variant-select]');
    const variantHidden=section.querySelector('[data-product-variant-id]');
    const quantity=section.querySelector('[data-product-quantity]');
    const currentPrice=section.querySelector('[data-current-price]');
    const comparePrice=section.querySelector('[data-compare-price]');
    const addButton=section.querySelector('[data-add-to-cart]');
    const cardButton=section.querySelector('[data-card-checkout]');
    const stockNote=section.querySelector('[data-stock-note]');
    const isSpanish=(document.documentElement.lang||'').toLowerCase().startsWith('es');
    const labels=isSpanish
      ?{available:'Disponible',soldOut:'Agotado',add:'Añadir al carrito',unit:'unidad disponible',units:'unidades disponibles'}
      :{available:'Available',soldOut:'Sold out',add:'Add to cart',unit:'unit available',units:'units available'};

    const getState=()=>{
      const option=variantSelect?variantSelect.options[variantSelect.selectedIndex]:null;
      const source=option||quantity;
      return {
        available:source?(option?source.dataset.available==='true':source.dataset.variantAvailable==='true'):false,
        inventory:Math.max(0,parseInt(source?.dataset.inventory||'0',10)||0),
        managed:source?.dataset.inventoryManaged==='true',
        policy:(source?.dataset.inventoryPolicy||'').toLowerCase()
      };
    };

    const updateStockNote=state=>{
      if(!stockNote)return;
      stockNote.classList.toggle('is-sold-out',!state.available);
      if(!state.available){
        stockNote.innerHTML=`<span data-stock-text>${labels.soldOut}</span>`;
        return;
      }
      const limited=state.managed&&state.policy==='deny';
      const text=limited?`${state.inventory} ${state.inventory===1?labels.unit:labels.units}`:labels.available;
      stockNote.innerHTML=`<span class="virelto-stock-dot"></span><span data-stock-text>${text}</span>`;
    };

    const applyQuantityLimit=(state=getState())=>{
      if(!quantity)return 1;
      quantity.min='1';
      quantity.disabled=!state.available;
      if(!state.available){
        quantity.removeAttribute('max');
        quantity.value='1';
        return 1;
      }
      let value=parseInt(quantity.value||'1',10);
      if(!Number.isFinite(value)||value<1)value=1;
      if(state.managed&&state.policy==='deny'){
        const max=Math.max(1,state.inventory);
        quantity.max=String(max);
        if(value>max)value=max;
      }else{
        quantity.removeAttribute('max');
      }
      quantity.value=String(value);
      return value;
    };

    const updateButtons=state=>{
      if(addButton){
        addButton.disabled=!state.available;
        const label=addButton.querySelector('span');
        if(label)label.textContent=state.available?labels.add:labels.soldOut;
      }
      if(cardButton)cardButton.disabled=!state.available;
    };

    const normalizeKey=value=>String(value||'')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g,'')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g,'-')
      .replace(/^-+|-+$/g,'');

    const getVariantKey=option=>{
      if(!option)return'';
      const raw=option.dataset.variantTitle||String(option.textContent||'').split('—')[0];
      const key=normalizeKey(raw);
      const aliases={
        'onyx-black':'black',
        'pearl-white':'whited',
        'emerald-green':'green'
      };
      return aliases[key]||key;
    };

    const thumbMatchesVariant=(thumb,key)=>{
      if(!key)return false;
      let src=thumb.dataset.imageSrc||'';
      try{src=decodeURIComponent(src);}catch(error){}
      const filePart=(src.split('?')[0].split('/').pop()||'').toLowerCase();
      const normalizedFile=normalizeKey(filePart);
      const normalizedAlt=normalizeKey(thumb.dataset.imageAlt||'');
      return normalizedFile.includes(`-${key}-`)
        || normalizedFile.startsWith(`${key}-`)
        || normalizedFile.endsWith(`-${key}`)
        || normalizedAlt===key
        || normalizedAlt.startsWith(`${key}-`);
    };

    const getVariantImageIds=()=>{
      const json=section.querySelector('[data-variant-image-ids]');
      if(json){
        try{
          const parsed=JSON.parse(json.textContent||'[]');
          const ids=new Set(parsed.map(value=>String(value||'')).filter(Boolean));
          if(ids.size)return ids;
        }catch(error){}
      }

      const ids=new Set();
      variantSelect?.querySelectorAll('option[data-image-id]').forEach(option=>{
        const id=String(option.dataset.imageId||'');
        if(id)ids.add(id);
      });
      return ids;
    };

    const variantImageIds=getVariantImageIds();
    const productGalleryLimit=10;
    const strictVariantGallery=section.dataset.strictVariantGallery==='true';

    const buildProductGalleryBase=()=>{
      // The product gallery must keep useful product photos visible instead of
      // collapsing to only the images attached to variants.
      // Up to 20 images: show every imported product image.
      // More than 20 images: show 10 useful images, prioritizing variant images
      // and filling the remaining slots with additional product photos.
      if(thumbs.length<=20)return null;

      const chosen=[];
      const push=id=>{
        id=String(id||'');
        if(!id||chosen.includes(id)||chosen.length>=productGalleryLimit)return;
        chosen.push(id);
      };

      // Start with variant-linked media so shoppers can see different options.
      thumbs.forEach(item=>{
        const id=String(item.dataset.imageId||'');
        if(variantImageIds.has(id))push(id);
      });

      // Then add regular product/lifestyle/detail photos.
      thumbs.forEach(item=>push(item.dataset.imageId));
      return chosen;
    };

    const productGalleryBase=buildProductGalleryBase();

    const applyProductGalleryRule=option=>{
      if(strictVariantGallery){
        if(variantImageIds.size){
          thumbs.forEach(item=>{
            item.hidden=!variantImageIds.has(String(item.dataset.imageId||''));
          });
        }else{
          thumbs.forEach((item,index)=>{item.hidden=index>0;});
        }
        return;
      }

      if(thumbs.length<=20){
        // Never hide the supplier's additional product images when the gallery
        // is reasonably sized.
        thumbs.forEach(item=>{item.hidden=false;});
        return;
      }

      const allowed=new Set(productGalleryBase||[]);
      const selectedId=String(option?.dataset.imageId||'');

      // Always keep the currently selected variant image visible.
      if(selectedId&&!allowed.has(selectedId)){
        const visibleIds=[...allowed];
        let removable=[...visibleIds].reverse().find(id=>id!==selectedId&&!variantImageIds.has(id));
        if(!removable)removable=[...visibleIds].reverse().find(id=>id!==selectedId);
        if(removable)allowed.delete(removable);
        allowed.add(selectedId);
      }

      thumbs.forEach(item=>{
        item.hidden=!allowed.has(String(item.dataset.imageId||''));
      });
    };

    const filterGalleryForVariant=option=>{
      applyProductGalleryRule(option);

      const imageId=option?.dataset.imageId||'';
      let target=imageId
        ?thumbs.find(item=>String(item.dataset.imageId)===String(imageId)&&!item.hidden)
        :null;

      if(!target){
        target=getVisibleThumbs()[0]||null;
      }

      if(target){
        const targetIndex=thumbs.indexOf(target);
        if(targetIndex>=0){
          if(targetIndex!==activeIndex||!target.classList.contains('is-active'))showImage(targetIndex);
          else updateGalleryControls();
          return;
        }
      }

      updateGalleryControls();
    };

    const refreshVariant=()=>{
      const state=getState();
      const option=variantSelect?variantSelect.options[variantSelect.selectedIndex]:null;

      if(option&&currentPrice)currentPrice.textContent=option.dataset.price||currentPrice.textContent;
      if(option&&comparePrice){
        if(option.dataset.comparePrice){
          comparePrice.textContent=option.dataset.comparePrice;
          comparePrice.hidden=false;
        }else{
          comparePrice.textContent='';
          comparePrice.hidden=true;
        }
      }

      updateButtons(state);
      updateStockNote(state);
      applyQuantityLimit(state);
      filterGalleryForVariant(option);

      if(option){
        const url=new URL(window.location.href);
        url.searchParams.set('variant',option.value);
        window.history.replaceState({},'',url);
      }
    };

    variantSelect?.addEventListener('change',refreshVariant);
    quantity?.addEventListener('input',()=>applyQuantityLimit());
    quantity?.addEventListener('change',()=>applyQuantityLimit());
    quantity?.addEventListener('blur',()=>applyQuantityLimit());
    form?.addEventListener('submit',async event=>{
      applyQuantityLimit();
      if(!window.fetch)return;
      event.preventDefault();

      const state=getState();
      if(!state.available||form.dataset.adding==='true')return;

      const rootPath=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
      const label=addButton?.querySelector('span');
      const addingText=isSpanish?'Añadiendo…':'Adding…';
      const addedText=isSpanish?'Agregado ✓':'Added ✓';
      const errorText=isSpanish?'No se pudo agregar':'Could not add';

      form.dataset.adding='true';
      if(addButton)addButton.disabled=true;
      if(label)label.textContent=addingText;

      try{
        const payload=new FormData(form);
        const response=await fetch(rootPath+'cart/add.js',{
          method:'POST',
          headers:{'Accept':'application/json'},
          body:payload
        });
        const result=await response.json().catch(()=>({}));
        if(!response.ok)throw new Error(result?.description||result?.message||'Unable to add item');

        const cartResponse=await fetch(rootPath+'cart.js',{
          headers:{'Accept':'application/json'},
          cache:'no-store'
        });
        if(!cartResponse.ok)throw new Error('Unable to refresh cart');
        const cart=await cartResponse.json();

        document.querySelectorAll('[data-cart-count]').forEach(el=>{
          el.textContent=String(cart.item_count);
          el.hidden=false;
          try{
            el.animate(
              [{transform:'scale(1)'},{transform:'scale(1.45)'},{transform:'scale(1)'}],
              {duration:420,easing:'ease-out'}
            );
          }catch(error){}
        });

        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));

        if(label)label.textContent=addedText;
        window.setTimeout(()=>{
          const latestState=getState();
          if(label)label.textContent=latestState.available?labels.add:labels.soldOut;
          if(addButton)addButton.disabled=!latestState.available;
        },1200);
      }catch(error){
        if(label)label.textContent=errorText;
        if(stockNote){
          stockNote.classList.add('is-sold-out');
          stockNote.innerHTML=`<span data-stock-text>${error?.message||errorText}</span>`;
        }
        window.setTimeout(()=>{
          const latestState=getState();
          if(label)label.textContent=latestState.available?labels.add:labels.soldOut;
          updateStockNote(latestState);
          if(addButton)addButton.disabled=!latestState.available;
        },1600);
      }finally{
        form.dataset.adding='false';
      }
    });

    cardButton?.addEventListener('click',()=>{
      const state=getState();
      if(!state.available)return;
      const variantId=variantSelect?variantSelect.value:variantHidden?.value;
      const qty=applyQuantityLimit(state);
      if(!variantId)return;
      const rootPath=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
      window.location.assign(`${rootPath}cart/${encodeURIComponent(variantId)}:${qty}?checkout`);
    });

    refreshVariant();
  });
});